<template>
    <div :class="{ input: true, 'label-left': position === 'left' }">
        <label class="login-label" :for="label">{{ label }}</label>
        <div class="login-input">
            <input type="text" :focus="isAutoFocus" :id="keyname" :ref="keyname" :value="value" @input="onInput"
                @focus="onFocus" @blur="onBlur" :disabled="isDisabled"
                :type="password && !showPassword ? 'password' : 'text'" :placeholder="focus ? '' : placeholder"
                placeholder-class="login-input-placeholder" :class="{ 'login-input-inp': 'true' }"
                :style="isDisabled ? 'color: #8b97a6;' : ''" />
            <div class="after-icon__eye" v-if="password && isShowIcon" @click="doShow">
                <img :src="showPassword ? '../assets/img/icon_xianshi_on.png' : '../assets/img/icon_xianshu_off.png'" />
            </div>
            <div :class="[password && modelValue.toString().length ? 'before-icon' : 'after-icon']"
                v-if="clearable && modelValue.toString().length && focus && isShowIcon" @click="doClear"
                @touchstart="doClear">
                <img style="width: 28px;height: 28px;" src="../assets/img/icon_shanchu.png" />
            </div>
            <slot></slot>
        </div>
        <div class="error"> <span v-if="errorMsg">{{ errorMsg }}</span></div>
    </div>
</template>

<script>
import { validationFunctions } from '@/util/verifyMap.js'
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        password: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: true
        },
        isShowIcon: {
            type: Boolean,
            default: true
        },
        isAutoFocus: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        keyname: {
            type: String,
            default: ''
        },
        position: {
            type: String,
            default: 'top'
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            modelValue: this.value,
            focus: false,
            showPassword: false,
            errorMsg: '',
        };
    },
    mounted() {
        //处理自动聚焦 要传keyname
        setTimeout(() => {
            if (this.isAutoFocus) {
                this.onFocus()
            }
        }, 200)
    },
    methods: {
        onInput(e) {
            this.$emit('input', e.target.value);
            this.validate(e.target.value);
        },
        onFocus() {
            this.focus = true;
            this.validate(this.value);
        },
        onBlur(e) {
            this.focus = false;
            this.$emit('input', e.target.value);
            this.validate(e.target.value);
        },
        doClear() {
            this.showPassword = false;
            this.$emit('input', '');
            this.errorMsg = ''; // 清空错误信息
        },
        doShow() {
            this.focus = true;
            this.showPassword = !this.showPassword;
            this.errorMsg = ''; // 清空错误信息
        },
        validate(value) {
            this.errorMsg = '';
            if (!this.rules) return;
            for (const rule of this.rules) {
                const validateFn = validationFunctions[rule.type];
                if (validateFn && !validateFn(value, rule)) {
                    this.errorMsg = rule.message || '格式不对';
                    this.$emit('dropDownValueChange', false, this.keyname);
                    break;
                }
            }
            if (!this.errorMsg) {
                this.$emit('dropDownValueChange', true, this.keyname);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.input.label-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .login-label {
        width: 64px;
        font-size: 14px;
    }

    .login-input {
        flex: 1;
        margin-top: 0;
    }
}

.login-label {
    color: #111827;
    font-size: 14px;
    font-weight: 600;
}

.login-input {
    position: relative;
    width: 100%;
    height: 48px;
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    border-radius: 5px;
    overflow: hidden;
    background: #fff;
    box-sizing: border-box;
    padding: 0 14px;
    margin-top: 8px;
    border: 1px solid #dce3ed;
    margin-bottom: 5px;

    &-inp {
        width: 90%;
        height: 48px;
        padding: 0;
        margin: 0;
        border: none;
        background: #fff;
    }

    &-placeholder {
        font-size: 14px;
        font-weight: 500;
        line-height: 48rpx;
        color: #8b97a6;
    }

    .after-icon {
        position: absolute;
        right: 10rpx;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        z-index: 10;

        image {
            width: 24px;
            height: 24px;
            padding: 15px;
        }
    }

    .after-icon__eye {
        position: absolute;
        right: 10rpx;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        z-index: 10;

        image {
            width: 24px;
            height: 24px;
        }
    }

    .before-icon {
        position: absolute;
        right: 76rpx;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        z-index: 10;
    }
}

.error {
    margin-top: 10px;
    color: red;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/normalInput.vue